import React from "react";
import { NavLink } from "react-router-dom";
import {
  FiHome,
  FiUpload,
  FiFilePlus,
  FiList,
  FiClock,
  FiEdit3,
  FiDownload,
  FiTrash2
} from "react-icons/fi";

import logo from "../../assets/argencis-logo.png"; 
import "./Sidebar.css";

export default function Sidebar() {
  return (
    <div className="sidebar">

      {/* Logo */}
      <div className="sidebar-logo-wrapper">
        <img src={logo} alt="Argencis Logo" className="sidebar-logo" />
      </div>

      {/* ----------- GROUP: Orders ----------- */}
      <div className="sidebar-section-label">ORDERS</div>

      <NavItem icon={<FiHome />} label="Dashboard" to="/admin" />
      <NavItem icon={<FiUpload />} label="Upload CSV" to="/admin/upload" />
      <NavItem icon={<FiFilePlus />} label="Enter Manually" to="/admin/manual" />
      <NavItem icon={<FiList />} label="View Orders" to="/admin/view" />

      {/* ----------- GROUP: History ----------- */}
      <div className="sidebar-section-label">HISTORY</div>

      <NavItem icon={<FiClock />} label="Recents" to="/admin/recents" />
      <NavItem icon={<FiDownload />} label="Download" to="/admin/download" />

      {/* ----------- GROUP: Admin ----------- */}
      <div className="sidebar-section-label">ADMIN</div>

      <NavItem icon={<FiEdit3 />} label="Edit" to="/admin/edit" />

      {/* NEW: Delete Orders */}
      <NavItem icon={<FiTrash2 />} label="Delete Orders" to="/admin/delete-orders" />
    </div>
  );
}

function NavItem({ icon, label, to }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        "sidebar-item" + (isActive ? " sidebar-item-active" : "")
      }
    >
      <span className="sidebar-icon">{icon}</span>
      <span className="sidebar-label">{label}</span>
    </NavLink>
  );
}
